import { Form, FormContext, FileUpload, FormErrorTypes } from 'dash-ui';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorCode } from 'react-dropzone';
import { FormFields } from 'containers/properties/PropertyInventory/components/AddPropertyInventoryModal/constants/constants';
import { DashValidation, FileModel } from 'dash-common';
import { type IOnUploadOptionsProps } from 'dash-ui';
import useFormDraftFileUpload from 'common/hooks/useDraftFileUpload';

const FloorPlan = () => {
  const { t } = useTranslation(['forms', 'common', 'pages']);
  const { formErrors, formState, stateHandlers, errorHandlers } =
    useContext(FormContext);

  const draftFileUpload = useFormDraftFileUpload();

  const onFileChanged = (fileId: string) => {
    stateHandlers[FormFields.FloorPlanFileId](fileId || null);
    errorHandlers[FormFields.FloorPlanFileId](null);
    stateHandlers[FormFields.FloorPlanLoading](false);
  };

  const onFileUpload = (file: File, options: IOnUploadOptionsProps) => {
    errorHandlers[FormFields.FloorPlanFileId](null);
    stateHandlers[FormFields.FloorPlanLoading](true);
    draftFileUpload(file, options);
  };

  return (
    <Form.Group mt={3}>
      <Form.Label>{t`labels.floorplan`}</Form.Label>
      <FileUpload.Single
        defaultValue={(formState.floorPlanFile as FileModel) || null}
        accept={{ 'application/pdf': ['.pdf'] }}
        onUpload={onFileUpload}
        onChanged={onFileChanged}
        maxSize={DashValidation.MaxLogoFileSize}
        onDropRejected={(error) => {
          let message = 'forms:messages:uploadErrors:unknown';
          if (error.code === ErrorCode.FileInvalidType) {
            message = 'forms:messages:uploadErrors:fileInvalidType';
          }
          if (error.code === ErrorCode.FileTooLarge) {
            message = 'forms:messages:uploadErrors:fileTooLarge';
          }
          errorHandlers[FormFields.FloorPlanFileId]({
            type: FormErrorTypes.Invalid,
            message: t(message, {
              type: '.pdf',
              maxSize: DashValidation.MaxLogoFileSize / 1024 / 1024,
            }),
          });
        }}
        $errorType={formErrors[FormFields.FloorPlanFileId]?.type}
      />
      <Form.Feedback $errorType={formErrors[FormFields.FloorPlanFileId]?.type}>
        {formErrors[FormFields.FloorPlanFileId]?.message}
      </Form.Feedback>
    </Form.Group>
  );
};

export default FloorPlan;
